import classnames from 'classnames';
import { type FunctionComponent } from 'react';

import styles from './Title.module.scss';

export interface TitleProps {
  className?: string;
  promoted?: boolean;
  text: string;
  displayThreeLines?: boolean;
}

const NON_BREAKING_SPACE = ' ';
const BREAKING_SPACE = ' ';
const NON_BREAKING_SPACE_REGEXP = new RegExp(NON_BREAKING_SPACE, 'g');

export const Title: FunctionComponent<TitleProps> = ({
  className,
  promoted = false,
  text,
  displayThreeLines = false,
}) => {
  const rootClassNames = classnames(styles.root, className, {
    [styles.promoted]: promoted,
    [styles.emptyTechnicalInfoTag]: displayThreeLines,
  });

  const formattedText = text.replace(NON_BREAKING_SPACE_REGEXP, BREAKING_SPACE);

  return (
    <p className={rootClassNames} data-testid="product-card-listings-title">
      {formattedText}
    </p>
  );
};

Title.displayName = 'Title';
